import ScedCatalog from "./ScedCatalog";
import { useState } from "react";
export default function CipCatalog({ cip, cipCatalog }) {


    const [isShowing, setIsShowing] = useState(false)

    return (

        <div className="bg-white pb-4 px-4">
            {cipCatalog && cipCatalog.cipDetails && (
                <div className="">

                    <p className={isShowing ? "font-light text-slate-700 px-5 whitespace-pre-wrap" : "font-light text-slate-700 px-5 line-clamp-2 whitespace-pre-wrap"}>
                        {cipCatalog.cipDetails.cipDesc}</p>
                    <button onClick={() => setIsShowing((isShowing) => !isShowing)}
                        className="print:hidden flex items-center text-md pl-5 p-2 text-blue-500 italic hover:underline">
                        {isShowing ? "show less course info" : "show additional course info..."}


                    </button>

                    {isShowing &&
                        <div className="inline-block w-full align-top bg-slate-50 p-8 text-sky-700 font-light">
                            <div className="grid grid-cols-3 gap-1 content-start ...">
                                <div className="col-span-2">
                                    <ScedCatalog cipCatalog={cipCatalog.cipDetails} />
                                </div>
                                <div className="rounded-r-sm bg-slate-200">
                                    <div className="px-4 pt-6 pb-2">
                                        <span className="font-semibold">Exploratory or Prepatory: </span>
                                        <span>{cipCatalog.cipDetails.exploreOrPrep}</span></div>
                                    <div className="p-2 px-4">
                                        <span className="font-semibold">Nontraditional Gender: </span>
                                        <span>{cipCatalog.cipDetails.nonTrad}</span></div>
                                    <div className="p-2 px-4">
                                        <span className="font-semibold">CTSO: </span>
                                        <span>{cipCatalog.cipDetails.ctso}</span></div>
                                    <div className="p-2 px-4">
                                        <span className="font-semibold">Teacher Cert V-Code: </span>
                                        <span>{Array.isArray(cipCatalog.cipDetails.vCodes) ? cipCatalog.cipDetails.vCodes.map(v => v.trim()).join(", ") : cipCatalog.cipDetails.vCodes}</span></div>
                                </div>
                            </div>
                        </div>

                    }
                </div>
            )}

        </div>

    )

}
